"use client"

import React from "react"
import PhoneInputBase from "react-phone-input-2"
import 'react-phone-input-2/lib/style.css'

interface PhoneInputProps {
  name: string
  value?: string
  onChange: (value: string) => void
  placeholder?: string
  defaultCountry?: string
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  name,
  value = "",
  onChange,
  placeholder = "Phone Number",
  defaultCountry = "us"
}) => {
  return (
    <PhoneInputBase
      country={defaultCountry}
      onlyCountries={['us', 'ca']}
      value={value}
      onChange={(phone) => {

        onChange(phone)
      }}
      inputProps={{
        name,
        required: true,
        autoFocus: false,
        placeholder
      }}
      placeholder="+1 234 567 890"
      searchPlaceholder="Search"
      disableCountryCode={false}
      containerClass="relative transition-all
        dark:border-gray-600 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-200 dark:focus-within:border-blue-500 dark:focus-within:ring-blue-900"
      inputClass="w-full !py-6 !bg-transparent !border-none focus:ring-0 focus:outline-none;"
    />
  )
}

export default PhoneInput